export enum ServerMessaeSide {
    Input = 0,
    Output = 1
}
